import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  label:      string;
  value:      string | number;
  icon?:      LucideIcon;
  trend?:     { value: number; label: string };
  className?: string;
}

export function StatCard({ label, value, icon: Icon, trend, className }: StatCardProps) {
  const isPositive = (trend?.value ?? 0) >= 0;
  return (
    <div className={cn("rounded-lg border border-border bg-card p-4 space-y-2", className)}>
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        {Icon && <Icon className="size-4 text-muted-foreground" strokeWidth={1.5} />}
      </div>
      <div className="text-2xl font-semibold font-display text-foreground">{value}</div>
      {trend && (
        <p className={cn("text-xs", isPositive ? "text-emerald-600" : "text-destructive")}>
          {isPositive ? "↑" : "↓"} {Math.abs(trend.value)}% {trend.label}
        </p>
      )}
    </div>
  );
}
